<template>
  <div>
    <el-form class="pinyin-form" ref="form" label-width="80px">
      <el-form-item label="课程">
        <el-input v-model="form.num"></el-input>
      </el-form-item>
      <el-form-item label="标题">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="图片">
        <FileInput v-model="form.image" accept="image/*"></FileInput>
      </el-form-item>
      <el-form-item label="有效">
        <el-switch v-model="form.status" :active-value="1" :inactive-value="0"></el-switch>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'LessonForm',
  components: {
    FileInput: require('@/components/FileInput').default
  },
  data () {
    return {
      form: {
        id: null,
        num: null,
        title: null,
        image: null,
        status: 1
      }
    }
  },
  methods: {
    reset (model) {
      this.form = Object.assign({
        id: null,
        num: null,
        title: null,
        image: null,
        status: 1
      }, model)
    },
    getFormData () {
      return {
        id: this.form.id,
        num: this.form.num,
        title: this.form.title,
        image: this.form.image,
        status: 1
      }
    },
    submit () {
      var params = this.getFormData()
      delete params.id
      if (this.form.id) {
        return this.$http.put(this.$urls.pinyin_lesson_update, params, {
          params: { id: this.form.id }
        })
      } else {
        return this.$http.post(this.$urls.pinyin_lesson_create, params).then(data => {
          this.form.id = data.id
        })
      }
    }
  }
}
</script>
